import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React__default from 'react';
import styled from 'styled-components';
import { Field } from 'formik';
import { borderCheck, backgroundCheck } from '../../theme/check-theme.js';
import img from '../../images/check_white.svg.js';
import '../media/Img.js';
import { Icon } from '../media/Icon.js';
import '../../theme/text-theme.js';
var _excluded = ["checked", "type", "onChange", "className", "style", "name", "disabled"];
styled(Icon).withConfig({
  displayName: "checkcomponent__Icon",
  componentId: "sc-10sikt4-0"
})(["transition:0.2s;"]);
var Container = styled.div.withConfig({
  displayName: "checkcomponent__Container",
  componentId: "sc-10sikt4-1"
})(["-webkit-appearance:none;display:flex;justify-content:center;align-items:center;width:24px;height:24px;border-radius:6px;box-sizing:border-box;transition:all 0.2s ease-out;"]);
var CheckWrapper = styled.div.withConfig({
  displayName: "checkcomponent__CheckWrapper",
  componentId: "sc-10sikt4-2"
})(["-webkit-appearance:none;display:flex;justify-content:center;align-items:center;width:22px;height:22px;border-radius:6px;", " ", " cursor:pointer;box-sizing:border-box;transition:all 0.2s ease-out;& > img{transition:opacity 0.2s ease-out;opacity:", ";}& *{user-select:none !important;}"], borderCheck, backgroundCheck, function (props) {
  return props.active == "true" ? 1 : 0;
});
/**
 * @deprecated
 */

var Check = function Check(_ref) {
  var checked = _ref.checked;
  _ref.type;
  var onChange = _ref.onChange,
    className = _ref.className,
    style = _ref.style,
    name = _ref.name,
    disabled = _ref.disabled;
  _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React__default.createElement(Container, {
    style: style
  }, /*#__PURE__*/React__default.createElement(CheckWrapper, {
    active: "" + checked,
    checked: checked,
    onClick: function onClick() {
      if (!disabled) {
        if (onChange) {
          onChange(!checked);
        }
      }
    },
    className: className
  }, /*#__PURE__*/React__default.createElement("img", {
    src: img,
    style: {
      width: "13px",
      height: "10px"
    }
  }), /*#__PURE__*/React__default.createElement(Field, {
    name: name,
    type: "checkbox",
    checked: checked,
    style: {
      display: "none"
    }
  })));
};
Check.defaultProps = {
  checked: false,
  disabled: false
};
export { Check as default };